import React, { useState } from 'react';
import { WatermarkPdf } from './WatermarkPdf';
import './Dashboard.css';
import { ReactComponent as IconWatermark } from './icons/watermark.svg';

const WatermarkPdfComponent = () => {
  const [pdfUrl, setPdfUrl] = useState(null);
  const [watermark, setWatermark] = useState('CONFIDENTIAL');

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const url = await WatermarkPdf(file, watermark);
    setPdfUrl(url);
  };

  return (
    <div>
    <div style={{ textAlign: 'center', paddingTop: 40, border: '1px solid #e0e0e0', padding: 16, borderRadius: 6 }}>
      <h2>Watermark PDF</h2>
      <input id="watermark-upload" type="file" accept="application/pdf" onChange={handleFileChange} style={{display:'none'}} />
      <label htmlFor="watermark-upload" className="tool-button"><IconWatermark aria-hidden="true"/> Choose PDF</label>
      <br />
      <input
        type="text"
        value={watermark}
        onChange={e => setWatermark(e.target.value)}
        placeholder="Enter watermark text"
        style={{ marginTop: 10 }}
      />
      <br />
      {pdfUrl && (
        <a className="tool-button" href={pdfUrl} download="watermarked.pdf" style={{display:'inline-flex', marginTop: 20}}><IconWatermark aria-hidden="true"/> Download Watermarked PDF</a>
      )}
    </div>
    <div className="content">

  <h2>Watermark PDF: Protect and Brand Your Documents Easily</h2>

  <p>
    Adding a watermark to your PDF is one of the most effective ways to protect 
    sensitive information, enhance your brand identity, or indicate document 
    ownership. The Watermark PDF tool allows you to insert customized text or image 
    watermarks across your pages with precision and style.
  </p>

  <p>
    From personal documents to business files, watermarks help ensure your PDFs 
    maintain authenticity and are used responsibly.
  </p>

  <h3>Why Add a Watermark?</h3>

  <ul>
    <li>Protect confidential or copyrighted content</li>
    <li>Brand documents with logos, names, or company details</li>
    <li>Mark drafts, samples, or non-final versions</li>
    <li>Discourage unauthorized copying or distribution</li>
    <li>Maintain consistent visual identity across shared files</li>
  </ul>

  <h3>How the Watermarking Process Works</h3>

  <h4>1. Upload Your PDF File</h4>
  <p>
    Begin by selecting the PDF you want to watermark. The tool loads the pages and 
    prepares them for customization.
  </p>

  <h4>2. Choose Your Watermark Type</h4>
  <p>
    You can apply either:
  </p>
  <ul>
    <li><strong>Text Watermark</strong> – Add words like “Confidential,” “Sample,” or custom text.</li>
    <li><strong>Image Watermark</strong> – Insert a logo, icon, or background image.</li>
  </ul>

  <h4>3. Customize the Watermark</h4>
  <p>
    Adjust your watermark to match your needs:
  </p>
  <ul>
    <li>Font style, size, and color (for text)</li>
    <li>Opacity (transparency level)</li>
    <li>Rotation angle (e.g., diagonal placement)</li>
    <li>Position on the page (center, top, bottom, corners)</li>
    <li>Size scaling (for logos or images)</li>
  </ul>

  <h4>4. Apply Watermark to All or Selected Pages</h4>
  <p>
    You can apply the watermark across every page in your document or choose specific 
    pages where it should appear.
  </p>

  <h3>Your Final Watermarked PDF</h3>
  <p>
    Once processed, your PDF will contain a clean, professional watermark that enhances 
    security and presentation. The file is ready for sharing, printing, or archiving, 
    with your custom branding or protection clearly in place.
  </p>

</div>

    </div>
  );
};

export default WatermarkPdfComponent;